import React from "react";
import { Link, Outlet } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks/redux-hooks";
import { Navigate } from "react-router-dom";

export const DefaultLayout = () => {
  const basicUserInfo = useAppSelector((state) => state.auth.basicUserInfo);

  const isAuthenticated = basicUserInfo && typeof basicUserInfo.id === "string" && basicUserInfo.id !== "";

  if (isAuthenticated) {
    // Redirect logged-in users away from public pages to the protected "gamehub"
    return <Navigate replace to="/gamehub" />;
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export default DefaultLayout;